<template>
  <div></div>
</template>

<script>
export default {
  name: "AuthCallback",
  created() {
    this.$auth0.handleAuthentication();
  }
};
</script>
